import { APP_LOGO_COLOR_SM } from '@constants/app.constant';
import { Link } from 'react-router-dom';

export const SidebarHeader = () => {
    return (
        <div className="border-box sticky top-0 z-10 h-[calc(var(--header-height)_-_1px)] bg-white px-4 py-2">
            <Link
                to="/home"
                className="flex w-[250px] items-center justify-start gap-2"
            >
                <img
                    className="h-10 w-10 object-contain"
                    src={APP_LOGO_COLOR_SM}
                    alt="Link Pharmacy Logo"
                />
                <span className="font-primary text-2xl font-bold">
                    Link Pharmacy
                </span>
            </Link>
        </div>
    );
};
